import { render, staticRenderFns } from "./DevPageKS2.vue?vue&type=template&id=4fa25d7e&scoped=true"
import script from "./DevPageKS2.vue?vue&type=script&lang=js"
export * from "./DevPageKS2.vue?vue&type=script&lang=js"
import style0 from "./DevPageKS2.vue?vue&type=style&index=0&id=4fa25d7e&prod&lang=css"
import style1 from "./DevPageKS2.vue?vue&type=style&index=1&id=4fa25d7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa25d7e",
  null
  
)

export default component.exports